import Headphones from "ui/icons/headphones";

interface Props {}

export default function ReferenceOverlay({}: Props) {
  return (
    <div className={"absolute inset-0 cursor-pointer md:h-auto"}>
      <div className={"hidden h-full md:block"}>
        <div className={"z-10 grid h-full grid-cols-[1fr,400px] bg-purple-700"}>
          <div className={"relative overflow-hidden"}>
            <Headphones className="absolute -bottom-10 -right-0 -top-4 h-[110%] fill-purple-400" />
          </div>

          <div className={"px-8 py-16 text-purple-400"}>
            <div className={"sticky top-20 "}>
              <div className={"mb-2 font-brik text-4xl leading-none"}>
                {title}
              </div>
              <div className={"mb-10"}>{desc}</div>
              <div
                className={
                  "whitespace-nowrap rounded border-2 border-purple-400 p-2 font-brik "
                }
              >
                {cta}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={"md:hidden"}>
        <div
          className={
            "absolute inset-0 z-10 bg-purple-700 px-8 pb-10 pt-24 sm:px-14"
          }
        >
          <div
            className={
              "stick absolute inset-0 top-0 flex items-start justify-center overflow-hidden py-16"
            }
          >
            <Headphones className="w-full scale-125 fill-purple-500" />
          </div>

          <div className={"sticky top-10"}>
            <div className={"mb-8 text-center"}>
              <div className={"mb-2 font-brik text-3xl leading-none"}>
                {title}
              </div>

              <div className={"text-base"}>{desc}</div>
            </div>

            <div
              className={
                "rounded border-2 border-purple-400 p-2 text-center font-brik leading-none"
              }
            >
              {cta}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const title = "You are listening to the Reference track";
const desc =
  "At the moment you are listening to the reference track. The reference track is an already mixed version of this loop. Your goal is to make your mix sound exactly like the reference track.";
const cta = "Click to Return to Your Mix";
